export default "__VITE_ASSET__8pi$iKWt__"